module.exports = __webpack_public_path__ + "img/kyani-pictorial-mark.a0d4639b.svg";